"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.languagesProviderActions = exports.initialState = void 0;
const _reduxjs_1 = require("../../utils/@reduxjs");
const env_1 = require("../../utils/env");
const lang_1 = require("../../utils/lang");
const REDUCER_KEY = 'languagesProvider';
// The initial state of the languagesProvider container
exports.initialState = (0, _reduxjs_1.getPreloadedState)(REDUCER_KEY, {
    languages: {},
    currentLangCode: (0, lang_1.getCurrentLng)(),
    fetchItems: {
        loading: true,
        error: null,
        refreshLoading: false,
        loaded: false,
    },
});
const languagesProviderSlice = (0, _reduxjs_1.createSlice)({
    name: REDUCER_KEY,
    initialState: exports.initialState,
    reducers: {
        fetchLanguages(state, _action) {
            state.fetchItems.loading = true;
            state.fetchItems.error = null;
            state.cacheable = false;
        },
        fetchLanguagesV2(state, _action) {
            state.fetchItems.loading = true;
            state.fetchItems.error = null;
            state.cacheable = false;
        },
        fetchLanguagesSuccess(state, { payload }) {
            const currentLangCode = (0, lang_1.getCurrentLng)();
            const items = payload.languages.items.map((item) => ({
                ...item,
                code: item.code.toLocaleLowerCase(),
            }));
            if (env_1.isBrowser && state.languages[currentLangCode]) {
                state.currentLangCode = currentLangCode;
            }
            state.languages = (0, _reduxjs_1.toIdsMap)(items, 'code');
            state.fetchItems.loading = false;
            state.fetchItems.error = null;
            state.fetchItems.loaded = true;
            state.cacheable = payload.fromServer;
        },
        fetchLanguagesError(state, action) {
            state.fetchItems.loading = false;
            state.fetchItems.error = action.payload;
            state.cacheable = false;
        },
        setLanguages(state, action) {
            state.languages = action.payload.data.languages;
            state.fetchItems = action.payload.data.fetchItems;
            state.cacheable = false;
        },
        setLanguagesInitialState(state, action) {
            state.currentLangCode = action.payload.langCode;
        },
        setCurrentLanguageCode(state, action) {
            state.currentLangCode = action.payload.langCode;
        },
    },
});
exports.languagesProviderActions = languagesProviderSlice.actions, exports.reducer = languagesProviderSlice.reducer, exports.sliceKey = languagesProviderSlice.name;
//# sourceMappingURL=slice.js.map